const i18n = {
	appealChangeHistory: {
		0 : "Паглядзець гісторыю працы са зваротам",
		1 : "Посмотреть историю работы с обращением"
	},
	emptyHistory: {
		0 : "Дадзеныя аб гісторыі працы з зваротам адсутнічаюць.",
		1 : "Данные об истории работы с обращением отсутствуют."
	},
	redirectFrom: {
		0 : "Перанакіравана з",
		1 : "Перенаправлено из"
	},
	redirectTo: {
		0 : "Перанакіравана ў",
		1 : "Перенаправлено в"
	},
	requestFrom: {
		0 : "Адказ атрыманы з",
		1 : "Ответ получен из"
	},
	requestTo: {
		0 : "Запыт накіраваны ў",
		1 : "Запрос направлен в"
	},
	searchHistory: {
		0 : "Пачакайце, ідзе пошук дадзеных пра гісторыю працы са зваротам...",
		1 : "Подождите, идёт поиск данных об истории работы с обращением..."
	},
	typeChange: {
		0: [
			"Падача звароту",
			"Адкліканне звароту",
			"Стварэнне звароту",
			"Рэгістрацыя звароту",
			"Зварот пакінуты без разгляду па сутнасці",
			"Перанакіраванне звароту",
			"Стварэнне рэзалюцыі",
			"Стварэнне праекта рэзалюцыі",
			"Выдаленне рэзалюцыі",
			"Зацвярджэнне праекта адказу",
			"Адпраўка адказу на зварот заяўніку",
			"Зацвярджэнне праекта рэзалюцыі",
			"Фарміраванне праекта адказу",
			"Перанакіраванне часткі пытанняў звароту",
			"Перанакіраванне звароту з пастаноўкай на кантроль",
			"Рэдагаванне звароту",
			"Кірунак запыту ў ДО",
			"Атрыманне адказу на запыт з ДО",
			"Стварэнне формы перанакіравання",
			"Падпісанне формы перанакіравання",
			"Загрузка звароту праз файл",
			"Адхіленне праекта рэзалюцыі",
			'Змяненне тэрміну выканання звароту',
			'Прыняцце да ўвагі',
			'Перададзена выканаўцу',
			'Створана справаздача для арганізацыі-кантралёраў, дадзены адказ для заяўніка',
			'Створана даручэнне арганізацыяй-кантралёрам',
			'Справаздача была прынята арганізацыяй-кантралёрам',
			'Дададзены прамежкавы вынік'
		],
		1: [
			"Подача обращения",
			"Отзыв обращения",
			"Создание обращения",
			"Регистрация обращения",
			"Обращение оставлено без рассмотрения по существу",
			"Перенаправление обращения",
			"Создание резолюции",
			"Создание проекта резолюции",
			"Удаление резолюции",
			"Утверждение проекта ответа",
			"Направление ответа на обращение заявителю",
			"Утверждение проекта резолюции",
			"Формирование проекта ответа",
			"Перенаправление части вопросов обращения",
			"Перенаправление обращения с постановкой на контроль",
			"Редактирование обращения",
			"Направление запроса в ГО",
			"Получение ответа на запрос из ГО",
			"Создание формы перенаправления",
			"Подписание формы перенаправления",
			"Загрузка обращения через файл",
			"Отклонение проекта резолюции",
			'Изменение срока исполнения обращения',
			'Принятие к сведению',
			'Передано исполнителю',
			'Создан отчёт для организации-контролеров, дан ответ для заявителя',
			'Создано поручение организацией-контролером',
			'Отчёт был принят организацией-контролером',
			'Добавлен промежуточный результат'
		]
	},
	user: {
		0 : "Карыстальнік",
		1 : "Пользователь"
	},
	organization: {
		0 : "Арганізацыя: {0}",
		1 : "Организация: {0}"
	}
}

export default i18n
